import Widgets from 'js-widget-hooks';
import $ from '../../util/jQuery';


Widgets.register('confirm', function (el) {

    const elem = $(el);

    elem.on('click', function (e) {
        if (!confirm('Sind Sie sicher?')) {
            e.preventDefault();
        }
    });
});